<template>
  <div class="encounter-vital-signs">
    <v-form
      v-on:submit.prevent
      class="encounter-form"
    >
      <v-simple-table class="encounter-form__table no-number-ticks">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>
                <!-- Note: English by specs -->
                {{ 'Body weight' }}
              </td>
              <td colspan="2">
                <v-text-field
                  v-model="bodyWeight"
                  suffix="kg"
                  outlined
                  dense
                  :errorMessages="errorMessages.bodyWeight"
                  @blur="() => setErrorMessage('bodyWeight')"
                  :disabled="!canEditVisitData"
                  type="number"
                  min="0"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>
                <!-- Note: English by specs -->
                {{ 'Blood pressure' }}
              </td>
              <td style="width: unset">
                <v-text-field
                  v-model="bloodPressureSystolic"
                  :label="$ucfirst($t('reportParametersHomeScreen.systolic', { catalog : 'app_mobile', language : 'en'}))"
                  suffix="mmHg"
                  outlined
                  dense
                  :errorMessages="errorMessages.bloodPressureSystolic"
                  @blur="() => setErrorMessage('bloodPressureSystolic')"
                  :disabled="!canEditVisitData"
                  type="number"
                  min="0"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  v-model="bloodPressureDiastolic"
                  :label="$ucfirst($t('reportParametersHomeScreen.diastolic', { catalog : 'app_mobile', language : 'en'}))"
                  suffix="mmHg"
                  outlined
                  dense
                  :errorMessages="errorMessages.bloodPressureDiastolic"
                  @blur="() => setErrorMessage('bloodPressureDiastolic')"
                  :disabled="!canEditVisitData"
                  type="number"
                  min="0"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>
                <!-- Note: English by specs -->
                {{ 'Pulse Rate' }}
              </td>
              <td colspan="2">
                <v-text-field
                  v-model="pulseRate"
                  suffix="bpm"
                  outlined
                  dense
                  :errorMessages="errorMessages.pulseRate"
                  @blur="() => setErrorMessage('pulseRate')"
                  :disabled="!canEditVisitData"
                  type="number"
                  min="0"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import encounterMixin from 'dashboard/mixins/encounter.mixin';

/**
 * Component VitalSigns.vue
 *
 * @module VitalSigns
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/templates/views/Encounter/VitalSigns.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'VitalSigns',
  mixins: [encounterMixin],
  data() {
    return {
      errorMessages: {
        bodyWeight: '',
        bloodPressureSystolic: '',
        bloodPressureDiastolic: '',
        pulseRate: '',
      },
    };
  },
  methods: {
    updateMyDSSInfo: function(){
      this.$store.dispatch('encounter/getEncounterMyDSSInfo');
    },
  },
  watch: {
    bloodPressureSystolic() {
      // meanBloodPressureAboveGoal field needs to be recalculated based on given blood pressure
      this.updateMyDSSInfo()
    },
    bloodPressureDiastolic() {
      // meanBloodPressureAboveGoal field needs to be recalculated based on given blood pressure
      this.updateMyDSSInfo()
    },
  },
  computed: {
    bodyWeight: {
      get() {
        return this.$store.getters['encounter/bodyWeight'];
      },
      set(bodyWeight) {
        this.$store.dispatch('encounter/setBodyWeight', bodyWeight);
      },
    },
    bloodPressureSystolic: {
      get() {
        return this.$store.getters['encounter/bloodPressureSystolic'];
      },
      set(systolic) {
        this.$store.dispatch('encounter/setBloodPressureSystolic', systolic);
      },
    },
    bloodPressureDiastolic: {
      get() {
        return this.$store.getters['encounter/bloodPressureDiastolic'];
      },
      set(diastolic) {
        this.$store.dispatch('encounter/setBloodPressureDiastolic', diastolic);
      },
    },
    pulseRate: {
      get() {
        return this.$store.getters['encounter/pulseRate'];
      },
      set(pulseRate) {
        this.$store.dispatch('encounter/setPulseRate', pulseRate);
      },
    },
  },
};
</script>
